module.exports = __webpack_public_path__ + "decd808ffbeaf07788e6ec40344ef500.png";